import { ModuleActionContract } from 'models'
import permissionService from 'Services/api/permission.service'
import {
    ENextModule,
    ENextModulePermission,
} from 'store/reducers/otherModuleAction.reducer'
import toast from 'utilities/toast/toast'
import { AppThunk, fetchWithNotification } from './base.action'

export const FETCH_OTHER_MODULE_ACTION_START = 'FETCH_OTHER_MODULE_ACTION_START'
export const FETCH_OTHER_MODULE_ACTION_FAILURE =
    'FETCH_OTHER_MODULE_ACTION_FAILURE'
export const FETCH_OTHER_MODULE_ACTION_SUCCESS =
    'FETCH_OTHER_MODULE_ACTION_SUCCESS'

export const CLEAR_OTHER_MODULE_ACTION = 'CLEAR_OTHER_MODULE_ACTION'

export const TOGGLE_PIN_DIALOG = 'TOGGLE_PIN_DIALOG'

export const SET_NEXT_MODULE = 'SET_NEXT_MODULE'

export const fetchOtherModuleActionStart = () => ({
    type: FETCH_OTHER_MODULE_ACTION_START,
})

export const fetchOtherModuleActionFailure = (err: any) => ({
    type: FETCH_OTHER_MODULE_ACTION_FAILURE,
    payload: err,
})

export const fetchOtherModuleActionSuccess = (
    payload: ModuleActionContract[],
    pin: string,
) => ({
    type: FETCH_OTHER_MODULE_ACTION_SUCCESS,
    payload: {
        pin,
        data: payload,
    },
})

const dispatchNextModule = (dispatch: any, module?: ENextModule) => {
    const moduleToggleAction: { [key in ENextModule]: any } = {
        [ENextModule.Discount]: undefined,
        [ENextModule.ServiceCharge]: undefined,
        [ENextModule.Void]: undefined,
        [ENextModule.PayIn]: undefined,
        [ENextModule.PayOut]: undefined,
        [ENextModule.Deposit]: undefined,
        [ENextModule.OpenTerminal]: undefined,
        [ENextModule.InactiveCashActivity]: undefined,
        [ENextModule.CloseTerminal]: undefined,
        [ENextModule.IssueRefund]: undefined,
        [ENextModule.ToptupGiftCard]: undefined,
        [ENextModule.TransferGiftCard]: undefined,
        [ENextModule.QuikcOutOfStock]: undefined,
        [ENextModule.SellGiftCard]: undefined,
        [ENextModule.OpenDrawer]: undefined,
        [ENextModule.VoidPayment]: undefined,
    }

    if (module && moduleToggleAction[module])
        return dispatch(moduleToggleAction[module])
}

export function fetchOtherModuleAction(pin: string): AppThunk {
    return async (dispatch, getState) => {
        dispatch(fetchOtherModuleActionStart())
        try {
            const res = await fetchWithNotification({
                apiLinkFnc: () =>
                    permissionService.fetchModuleActionFromPin(pin),
            })

            const overrideModules = res.data
            dispatch(fetchOtherModuleActionSuccess(res.data, pin))

            const nextModule = getState().otherModuleAction.nextModule
            if (nextModule) {
                const getPermissionFromModule =
                    ENextModulePermission[nextModule]
                if (
                    !getPermissionFromModule ||
                    overrideModules
                        .map((m) => m.moduleActionID!!)
                        .some((s) => getPermissionFromModule.includes(s))
                ) {
                    dispatchNextModule(dispatch, nextModule)
                } else {
                    throw new Error('Access denied')
                }
            }
        } catch (err) {
            dispatch(fetchOtherModuleActionFailure(err))
            if (typeof err === 'string') toast.error(err)
        }
    }
}

export function togglePinDialog(open: boolean): AppThunk {
    return (dispatch) => {
        dispatch({ type: TOGGLE_PIN_DIALOG, payload: open })
    }
}
export function clearPermission(): AppThunk {
    return (dispatch) => {
        dispatch({ type: CLEAR_OTHER_MODULE_ACTION })
    }
}
export function setNextModule(payload: { module?: ENextModule }): AppThunk {
    return (dispatch) => {
        dispatch({ type: SET_NEXT_MODULE, payload: payload })
    }
}
